'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'space-station-moon-construction';
var width = 512;
var height = 512;
var aliases = ["space-station-moon-alt"];
var unicode = 'e034';
var svgPathData = ['M32 256c0 14.8 1.4 29.3 4.2 43.3c2.1 .7 4.2 1.5 6.5 2.3C79 314.7 142.1 337.4 256 337.4s177-22.7 213.3-35.8c2.3-.8 4.4-1.6 6.5-2.3c2.7-14 4.2-28.5 4.2-43.3l-48 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l44.7 0C372.3 56.4 317 32 256 32C132.3 32 32 132.3 32 256zm15.2 81.2C79.7 420.8 160.9 480 256 480c68.9 0 130.5-31.1 171.6-80L416 400c-8.8 0-16-7.2-16-16l0-28.6c-36.6 7.8-83.7 14.1-144 14.1c-104.8 0-169.6-18.7-208.8-32.3zM280 160a88 88 0 1 1 -176 0 88 88 0 1 1 176 0z', 'M32 256C32 132.3 132.3 32 256 32c61 0 116.3 24.4 156.7 64L368 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c6.1 0 11.6-3.4 14.3-8.9s2.1-11.9-1.5-16.8C414.1 40.2 339.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c91.2 0 171.3-47.7 216.6-119.5c3.1-4.9 3.3-11.2 .5-16.3s-8.2-8.3-14-8.3L416 368c-8.8 0-16 7.2-16 16s7.2 16 16 16l11.6 0c-41.1 48.9-102.7 80-171.6 80c-95.1 0-176.3-59.2-208.8-142.8c39.2 13.6 104 32.3 208.8 32.3c119.5 0 187-24.3 223.8-37.6c5-1.8 9.4-3.4 13.3-4.7c1.7-.6 3.2-1.4 4.6-2.4l1.7-1.3c3-2.3 5.1-5.5 5.9-9.1c4.4-18.7 6.7-38.3 6.7-58.3c0-5.7-.2-11.4-.6-17.1c-.6-8.4-7.5-14.9-16-14.9L432 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c0 14.8-1.4 29.3-4.2 43.3c-2.1 .7-4.2 1.5-6.5 2.3C433 314.7 369.9 337.4 256 337.4s-177-22.7-213.3-35.8c-2.3-.8-4.4-1.6-6.5-2.3c-2.7-14-4.2-28.5-4.2-43.3zm104-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-64 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSpaceStationMoonConstruction = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;